import React from 'react'
import classNames from 'classnames'
import { Select } from 'antd'
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import { pairCorrect } from '../../grading'
import own from './AnswerMatch.module.scss'

// type7: choose the matching answer for every prompt; each answer can be used once
function AnswerMatch({ question, draft, onChange, checked, order }) {
  const pairs = question.answers || []
  const byId = Object.fromEntries(pairs.map(_p => [_p._id, _p]))
  const used = Object.values(draft)

  return (
    <div className={own.list}>
      {pairs.map((pair, index) => {
        const correct = checked && pairCorrect(question, draft, pair)
        return (
          <div
            key={pair._id}
            className={classNames(own.row, { [own.correct]: correct, [own.wrong]: checked && !correct })}
          >
            <div className={own.prompt}>
              <span className={own.number}>{index + 1}</span>
              <span>{pair.question}</span>
            </div>
            <div className={own.choice}>
              <Select
                size="large"
                allowClear
                value={draft[pair._id]}
                disabled={checked}
                placeholder={i18n('qv_choose_match')}
                onChange={(value) => {
                  const next = { ...draft }
                  if (value) next[pair._id] = value
                  else delete next[pair._id]
                  onChange(next)
                }}
                options={order.map(id => ({
                  value: id,
                  label: byId[id]?.answer,
                  disabled: used.includes(id) && draft[pair._id] !== id,
                }))}
              />
              {checked && (correct
                ? <AiOutlineCheck className={own.statusOk} size={18} />
                : <AiOutlineClose className={own.statusBad} size={18} />)}
            </div>
            {checked && !correct && (
              <div className={own.fix}>{i18n('qv_correct_answer')}: <b>{pair.answer}</b></div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default AnswerMatch
